import { render, staticRenderFns } from "./AddressInputsCollapse.vue?vue&type=template&id=3f6495a0&scoped=true"
import script from "./AddressInputsCollapse.vue?vue&type=script&lang=ts"
export * from "./AddressInputsCollapse.vue?vue&type=script&lang=ts"
import style0 from "./AddressInputsCollapse.vue?vue&type=style&index=0&id=3f6495a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6495a0",
  null
  
)

export default component.exports